/*
 * @Description: Logo公用组件
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-05-08 14:11:40
 * @LastEditTime: 2019-05-08 14:27:59
 */


import React from 'react'
import withStyles from 'isomorphic-style-loader/lib/withStyles'
// @ts-ignore
import s from './Logo.css'
import Link from '../Link'
// @ts-ignore
import svgLogo from './logo.svg'
import classname from 'classnames'

class Logo extends React.Component {
  render() {
    const style = this.props.className || ''
    return (
      <Link to="/" className={classname(s.root, style)}>
        <img src={svgLogo} alt="DBRank" />
      </Link>
    )
  }
}

export default withStyles(s)(Logo)



// WEBPACK FOOTER //
// src/components/Logo/Logo.js